"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocationHash = exports.getQueryParameter = void 0;

var getQueryParameter = function getQueryParameter(name, url) {
  if (!url) url = window.location.href;
  url = url.toLowerCase(); // This is just to avoid case sensitiveness

  name = name.replace(/[\[\]]/g, '\\$&').toLowerCase(); // This is just to avoid case sensitiveness for query parameter name

  var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

exports.getQueryParameter = getQueryParameter;

var getLocationHash = function getLocationHash() {
  return window.location.hash !== '' ? window.location.hash.substr(1) : '';
};

exports.getLocationHash = getLocationHash;